const { ON_INACTIVE_CLIENT, ON_INACTIVE_CLIENT_SUCCESS, ON_INACTIVE_CLIENT_FAIL, GET_CLIENT_SETTING, GET_CLIENT_SETTING_SUCCESS, GET_CLIENT_SETTING_FAIL } = require("./actionType")


const INIT_STATE = {
    clientSetting: null,
    error: "",
    success: "",
    loading: false,
  }

  const reducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ON_INACTIVE_CLIENT:
        case GET_CLIENT_SETTING:
            return { ...state, loading: true }
        
            case ON_INACTIVE_CLIENT_SUCCESS:
                   return { ...state, 
                       loading: false
                   }
         case GET_CLIENT_SETTING_SUCCESS:
            return { ...state, 
                loading: false, 
                clientSetting: action.payload
            }
        case ON_INACTIVE_CLIENT_FAIL:
           case GET_CLIENT_SETTING_FAIL:
            return { ...state, 
                loading: false, 
                error: action.payload ? action.payload : "خطای پیش بینی نشده",
            }
      default:
        return { ...state }
    }
}

export default reducer